import { VStack, useBreakpointValue } from '@hover/blueprint';
import React, { useEffect } from 'react';

import { Web } from 'src/shared/constants/FeatureFlag';
import { useTreatment } from 'src/shared/hooks';
import {
  useClearGlobalStorageUpload,
  useGlobalStorageContext,
} from 'src/shared/hooks/useGlobalStorage';
import { useIsEmbed } from 'src/shared/hooks/useIsEmbed';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

import { useHomeownerAppContext } from '../../hooks/useHomeownerAppContext';
import { DesignerLandingPage } from '../DesignerLandingPage/DesignerLandingPage';
import { EmbeddedDesignerLandingPage } from '../DesignerLandingPage/EmbeddedDesignerLandingPage';
import { Footer } from '../Footer';
import { clearWelcomeAction, getWelcomeMenu } from '../WelcomeSheet';

import { LoggedInHome } from './LoggedInHome';
import { LoggedOutHome } from './LoggedOutHome';

const Home = () => {
  const { loggedIn, setCurrentMenu } = useHomeownerAppContext();
  const { homeownerAppUploadFile } = useGlobalStorageContext();
  const deviceSize = useBreakpointValue({ base: 'base', tablet: 'tablet' });

  const isEmbed = useIsEmbed();

  const isDesignerLandingPageEnabled = isEnabled(
    useTreatment(Web.DESIGNER_LANDING_PAGE),
  );

  const welcomeMenu = deviceSize === 'base' ? getWelcomeMenu() : undefined;

  useEffect(() => {
    if (homeownerAppUploadFile) return;

    if (welcomeMenu) {
      setCurrentMenu(welcomeMenu);
    } else {
      setCurrentMenu(null);
      clearWelcomeAction();
    }
  }, [welcomeMenu, setCurrentMenu, homeownerAppUploadFile]);

  useClearGlobalStorageUpload();

  // NOTE: the logged-in version of the home page isn't currently supported at
  // all in the embedded experience, so we always want to show the landing page
  if (isEmbed) return <EmbeddedDesignerLandingPage />;

  if (!loggedIn && isDesignerLandingPageEnabled) return <DesignerLandingPage />;

  return loggedIn ? (
    <LoggedInHome />
  ) : (
    <VStack>
      <LoggedOutHome />
      <Footer />
    </VStack>
  );
};

export { Home };
